import styled from "styled-components";

export const Main = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
`;

export const Padding = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Inner = styled.div`
    max-width: 500px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    background: white;
    -webkit-box-shadow: 0 2px 2px rgba(0,0,0,0.1);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    border-radius: 6px;
    padding: 25px;
`;

export const Icon = styled.div`
    font-size: 6rem;
    display: flex;
    align-items: center;
`;

export const Title = styled.div`
    width: 100%;
    font-size: 1rem;
    font-weight: 500;
    text-align: center;
`;

export const Message = styled.div`
    font-size: 0.9rem;
    width: 100%;
    text-align: center;
    white-space: pre-wrap;
`;